/**
 * Origins of OUR launcher shells that may frame the app and relay the
 * Telegram bridge to it.
 *
 * WHY THIS EXISTS. Telegram iOS binds its JS bridge to the origin of the URL
 * it launched (Telegram-iOS WebAppWebView.swift, securedEventProxySource:
 * `if (window.location.origin !== trustedOrigin) return;`, and sendEvent is
 * guarded the same way). Our launcher used to location.replace() to
 * kiss-date.ru / relay.kiss-date.ru, so on iOS the bridge vanished in both
 * directions and every iOS session ran without openLink, invoice.open, the
 * back button or viewport events — 2958/2958 platform-tagged degraded
 * launches and 12/12 iOS payers on 2026-09-04..06, against 0/16 on Android,
 * whose bridge has no origin check.
 *
 * The fix keeps the launcher document on the launch origin and runs the app
 * in an IFRAME from the probed host, relaying events — the exact contract
 * web.telegram.org uses, which @telegram-apps already speaks when
 * self !== top. The one thing the SDK cannot know is WHO the parent is: it
 * posts to window.parent with targetOrigin "https://web.telegram.org", and the
 * browser silently drops a postMessage whose targetOrigin does not match the
 * parent's origin. So when our own shell is the parent, the target origin
 * must be set to it — and to nothing else, ever: a page framed by an
 * unknown origin keeps the Telegram default and stays deaf, which is the safe
 * failure.
 */
export const LAUNCHER_ORIGINS: ReadonlyArray<string> = Object.freeze([
  'https://app.kiss-date.ru',
  'https://app.kiss-date.com',
  'https://poc.kiss-date.ru',
  'https://m.kiss-date.ru',
]);

/**
 * The parent origin to hand to `targetOrigin.set`, or undefined when the app
 * is not framed by one of our launchers.
 *
 * `ancestorOrigins` is `location.ancestorOrigins` — supported by WebKit and
 * Chromium, absent in Firefox. Firefox only ever frames us via
 * web.telegram.org, where the SDK default is already right, so "undefined"
 * there is correct rather than a gap.
 */
export const resolveLauncherTargetOrigin = (
  isFramed: boolean,
  ancestorOrigins: ArrayLike<string> | undefined,
): string | undefined => {
  if (!isFramed || !ancestorOrigins || ancestorOrigins.length === 0) {
    return undefined;
  }

  const parent = ancestorOrigins[0];

  return LAUNCHER_ORIGINS.includes(parent) ? parent : undefined;
};
